import { FC, useEffect } from 'react';
import { FooterContainer } from '../modules/footer/footer.container';
import { BannerContainer } from '../modules/banner/banner.container';
import { ContactUsContainer } from '../modules/contact-us/contact-us.container';
import { ServiceIndicator } from '../modules/service-indicators/service-indicator';
import { CategoriesSection } from '../modules/categories-section/categories-section';
// import { SecondaryBanners } from '../modules/secondary-banners/secondary-banners';
import { NewsSection } from '../modules/news-section/news-section';
import { ServiceMenuContainer } from '../modules/service-menu/service-menu.container';

export const Home: FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);
  return (
    <>
      <BannerContainer />
      <ServiceIndicator />
      <ServiceMenuContainer />
      <CategoriesSection />
      {/* <SecondaryBanners /> */}
      <NewsSection />
      <ContactUsContainer />
      <FooterContainer />
    </>
  );
};
